export const styles = () => ({
  title: {
    fontFamily: "Raleway",
    fontStyle: "normal",
    fontWeight: 500,
    fontSize: "24px",
    lineHeight: "28px",
    color: "#000000",
    "&& button": {
      position: "absolute",
      right: "10px",
      top: "5px",
      color: "#5c5b5b"
    },
    background: "white",
    borderBottom: "1px solid #dadada"
  },
  buttonClass: {
    height: 40,
    background: "#26BBED",
    color: "white",
    width: 82,
    padding: "8px 22px"
  },
  root: {
    display: "flex",
    background: "white",
    border: "1px solid #DADADA",
    padding: "0px 20px",
    justifyContent: "space-between",
  },
  copiedButton: {
    background: "#66D184",
    height: 40,
    color: "white",
    padding: "8px 22px",
    width: 110,
    display: "flex",
    justifyContent: "space-between",
    alignItems: "space-between",
  },
  dialogStyle: {
    borderRadius: 0
  },
  actions: {
    background: "white",
    display: "flex",
    padding: "24px 20px",
    justifyContent: "flex-end",
    cursor: "pointer"
  },
  viewStyle: {
    padding: 10,
    width: 460,
    wordBreak: "break-all",
    background: "#f9f9f9",
    height: 300,
    overflow: "auto",
    '&::-webkit-scrollbar': {
      width: '10px',
    },
    '&::-webkit-scrollbar-track': {
      borderRadius: 50,
    },
    '&::-webkit-scrollbar-thumb': {
      backgroundColor: 'rgba(0,0,0,.1)',
      borderRadius: 50,
    }
  },
  body: {
    padding: "24px 20px",
    paddingBottom: 0,
    background: "white",
    overflow: "hidden"
  },
  dottedLine: {
    border: "1px dashed #DADADA"
  },
  iconWeight: {
    fontWeight: "bold"
  },
  font: {
    fontWeight: "bold"
  },
  closeButton: {
    color: "black !important",
    "&:hover":{
      color:"#26bbed !important"
    }
  },
  bgGrey: {
    background: "#F9F9F9"
  }
});